(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/carousel/assets/javascripts/react/carousel-navigation-item.js') >= 0) return;  svs.modules.push('/components/lb-ui/carousel/assets/javascripts/react/carousel-navigation-item.js');

'use strict';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const IconButton = svs.ui.ReactIconButton;
const clx = svs.components.lbUtils.clx;
const CarouselNavigationItem = _ref => {
  let index = _ref.index,
    isActive = _ref.isActive,
    isSelected = _ref.isSelected,
    label = _ref.label,
    onChange = _ref.onChange,
    size = _ref.size;
  return React.createElement(IconButton, _extends({
    "aria-current": isSelected,
    "aria-label": label,
    className: clx('carousel-nav-item', {
      'carousel-nav-item-active': isSelected
    }),
    onClick: () => onChange(index)
  }, isActive ? {} : {
    tabIndex: -1
  }), React.createElement("span", {
    className: clx('carousel-nav-icon', "carousel-nav-icon-".concat(size))
  }));
};
CarouselNavigationItem.defaultProps = {
  size: '300'
};
setGlobal('svs.components.lbUi.carousel.CarouselNavigationItem', CarouselNavigationItem);

 })(window);